export default __webpack_public_path__ + "static/media/BellIconWhite.3f9c1164.svg";